import { render, staticRenderFns } from "./MostVisitedPlaces.vue?vue&type=template&id=49b0403a&"
import script from "./MostVisitedPlaces.vue?vue&type=script&lang=js&"
export * from "./MostVisitedPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports